import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'
import NavDropdown from 'react-bootstrap/NavDropdown'
import Form from 'react-bootstrap/Form'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Badge from 'react-bootstrap/Badge'
import { connect } from 'react-redux'
import { isAdmin } from '../../route/admin'
import getApiEnvironment from '../../js/apiEnvironment'

const apiEnvironment = getApiEnvironment()

const searchCourses = (query) => ({
  type: 'SEARCH_COURSES',
  query,
})

function Menu({ games, players, user, dispatch }) {
  const [query, setQuery] = useState('')

  const handleChange = (event) => {
    setQuery(event.target.value)
  }

  const handleSearch = (event) => {
    event.preventDefault()
    dispatch(searchCourses(query))
  }

  const onLogin = (event) => {
    event.preventDefault()
    dispatch({ type: 'LOGIN' })
  }

  const onLogout = (event) => {
    event.preventDefault()
    dispatch({ type: 'LOGOUT' })
  }

  const renderAuth = () => {
    const login = (
      <Nav.Link as={Link} to="/login" onClick={onLogin}>
        Login
      </Nav.Link>
    )
    const logout = (user) => (
      <NavDropdown
        title={
          <img src={user.photoURL} className="user-photo-small" alt="User" />
        }
        id="nav-dropdown"
        align="end"
      >
        <NavDropdown.Item href="#" className="user-info">
          <img src={user.photoURL} className="user-photo-large" alt="User" />
          <br />
          <span className="user-name">{user.displayName}</span>
          <br />
          <span className="user-email">{user.email}</span>
        </NavDropdown.Item>
        <NavDropdown.Item href="/logout" title="" onClick={onLogout}>
          Logout
        </NavDropdown.Item>
      </NavDropdown>
    )

    return user ? logout(user) : login
  }

  const supportEmail = 'contact.codeunlimited+discgolf@gmail.com'
  const helpSubject = encodeURIComponent('Help with the App')
  const helpBody = encodeURIComponent(
    `Hi there,

  I need help with your app. Here are some details:

  - What I was trying to do:
  - What went wrong:
  - Device or platform I'm using:

  Thanks!`
  )
  const helpMailtoLink = `mailto:${supportEmail}?subject=${helpSubject}&body=${helpBody}`

  const feedbackSubject = encodeURIComponent('Feedback or Feature Suggestion')
  const feedbackBody = encodeURIComponent(
    `Hi there,

  I have some feedback about your app, or a suggestion for a new feature:

  - What I like or what works well:
  - What I think could be improved:
  - Feature idea (if any):

  Feel free to contact me if you need more details.

  Thanks!`
  )

  const feedbackMailtoLink = `mailto:${supportEmail}?subject=${feedbackSubject}&body=${feedbackBody}`
  return (
    <Navbar
      bg="primary"
      variant="dark"
      expand="lg"
      sticky="top"
      className="menu justify-content-between"
    >
      <Container>
        <Navbar.Brand href="/">
          <img src="/logo.png" alt="Discgolf" />
        </Navbar.Brand>
        {isAdmin(user) && (
          <Badge
            bg={apiEnvironment.variant}
            title={apiEnvironment.host}
            className="api-environment-badge"
          >
            {apiEnvironment.label}
          </Badge>
        )}
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/">
              Home
            </Nav.Link>
            {games && (
              <Nav.Link as={Link} to="/rounds">
                Rounds
              </Nav.Link>
            )}
            {players && (
              <Nav.Link as={Link} to="/players">
                Players
              </Nav.Link>
            )}
            {user && (
              <Nav.Link as={Link} to="/discs">
                Discs
              </Nav.Link>
            )}
            {isAdmin(user) && (
              <Nav.Link as={Link} to="/admin">
                Admin
              </Nav.Link>
            )}
            <NavDropdown
              title="Help"
              id="basic-nav-dropdown"
              className="d-none d-lg-block"
            >
              <NavDropdown.Item as={Link} to="/faq">
                FAQ
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/privacy">
                Privacy Policy
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="https://pdga.com" target="_blank">
                PDGA <i className="bi-box-arrow-up-right"></i>
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href={helpMailtoLink} target="_blank">
                Contact <i className="bi-envelope"></i>
              </NavDropdown.Item>
              <NavDropdown.Item href={feedbackMailtoLink} target="_blank">
                Feedback <i className="bi-envelope"></i>
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="https://codeunlimited.se" target="_blank">
                CodeUnlimited <i className="bi-box-arrow-up-right"></i>
              </NavDropdown.Item>
            </NavDropdown>
            <Nav.Link className="disabled d-lg-none">Help</Nav.Link>
            <Nav.Link className="d-lg-none" as={Link} to="/faq">
              &nbsp;&nbsp;FAQ
            </Nav.Link>
            <Nav.Link className="d-lg-none" as={Link} to="/privacy">
              &nbsp;&nbsp;Privacy Policy
            </Nav.Link>
            <Nav.Link
              className="d-lg-none"
              href="https://pdga.com"
              target="_blank"
            >
              &nbsp;&nbsp;PDGA <i className="bi-box-arrow-up-right"></i>
            </Nav.Link>
            <Nav.Link
              className="d-lg-none"
              href={helpMailtoLink}
              target="_blank"
            >
              &nbsp;&nbsp;Contact <i className="bi-envelope"></i>
            </Nav.Link>
            <Nav.Link
              className="d-lg-none"
              href={feedbackMailtoLink}
              target="_blank"
            >
              &nbsp;&nbsp;Feedback <i className="bi-envelope"></i>
            </Nav.Link>
            <Nav.Link
              className="d-lg-none"
              href="https://codeunlimited.se"
              target="_blank"
            >
              &nbsp;&nbsp;CodeUnlimited{' '}
              <i className="bi-box-arrow-up-right"></i>
            </Nav.Link>
          </Nav>
          <Nav>
            <Form onSubmit={handleSearch} className="d-none d-lg-block">
              <Row>
                <Col>
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    value={query}
                    onChange={handleChange}
                    className="me-sm-3"
                  />
                </Col>
              </Row>
            </Form>
          </Nav>
          <Nav>{renderAuth()}</Nav>
          <Nav>
            <Form onSubmit={handleSearch} className="d-lg-none">
              <Form.Control
                type="text"
                placeholder="Search"
                value={query}
                onChange={handleChange}
              />
            </Form>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}

const mapStateToProps = (state) => {
  const { players, courses, games } = state.user.data || {}
  return {
    user: state.auth.user,
    players,
    courses,
    games,
  }
}

export default connect(mapStateToProps)(Menu)
